var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"position-relative"},[_c('doughnut-chart',{attrs:{"chartdata":_vm.chartData,"options":_vm.options,"height":_vm.chartHeight}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }